import { Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeWhile } from 'rxjs';

import { IProfile, ProfilesService } from '@app/core/profiles';
import { ProfileDialogComponent } from '../profile-dialog/profile-dialog.component';
import { YesNoDialogComponent } from '@app/shared';

@Component({
  selector: 'app-profile-list',
  templateUrl: './profile-list.component.html'
})
export class ProfileListComponent {

  public records$: Subject<IProfile[]>;
  public selectedRecords: IProfile[];

  private destroyed: boolean;

  constructor(
    private service: ProfilesService,
    private dialogService: DialogService
  ) {
    this.records$ = new Subject();
    this.loadProfiles();
  }

  private loadProfiles(): void {

    this.selectedRecords = [];

    this.service.getList()
    .pipe(takeWhile(() => !this.destroyed))
    .subscribe(records => {
      this.records$.next(records);
    });
  }

  public onRowEdit(profile: IProfile): void {

    this.dialogService.open(ProfileDialogComponent, {
      data: {
        profile,
      },
      height: '600px',
      width: '800px',
      header: 'Editar perfil'
    })
    .onClose
    .pipe(takeWhile(() => !this.destroyed))
    .subscribe(profile => {
      if (profile) {
        this.loadProfiles();
      }
    });

  }

  public deleteSelected(): void {
    this.dialogService.open(YesNoDialogComponent, {
      height: '300px',
      width: '300px',
      header: 'Eliminar perfiles/s',
      data: {
        message: '¿Eliminar perfiles seleccionados?'
      }
    })
    .onClose
    .pipe(takeWhile(() => !this.destroyed))
    .subscribe(result => {

      if (result) {
        this.service
        .deleteProfile(this.selectedRecords.map(r => r.id))
        .pipe(takeWhile(() => !this.destroyed))
        .subscribe(() => {
          this.loadProfiles();
        })
      }

    })

  }

  public newProfile(): void {

    this.dialogService.open(ProfileDialogComponent, {
      height: '600px',
      width: '800px',
      header: 'Nuevo perfil'
    })
    .onClose
    .pipe(takeWhile(() => !this.destroyed))
    .subscribe(profile => {

      if (profile) {
        this.loadProfiles();
      }

    });

  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }

}
